import React from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {useAuth} from '../contexts/auth.context';

interface ForcePasswordChangeWrapperProps {
    children: React.ReactNode;
}

/**
 * Component that enforces password change when the user's account requires it.
 * If the user needs to change their password, they will be redirected to the
 * change-password page unless they are already on that page.
 */
const ForcePasswordChangeWrapper: React.FC<ForcePasswordChangeWrapperProps> = ({children}) => {
    let {user} = useAuth();
    const location = useLocation();
    user = user ? {...user, forcePasswordChange: false} : null;//temporarily remove forcePasswordChange flag
    // If the user is logged in and forcePasswordChange is true
    if (user?.forcePasswordChange) {
        // Only redirect if not already on the change-password page
        if (location.pathname !== '/change-password') {
            console.log('Redirecting to password change page due to forcePasswordChange flag');
            return <Navigate to="/change-password" state={{from: location}} replace/>;
        }
    }

    return <>{children}</>;
};

export default ForcePasswordChangeWrapper;
